import React from 'react';
import axios from 'axios';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Landing from './pages/Landing';
import Install from './pages/Install';
import LuggageForm from './pages/LuggageForm';
import Payment from './pages/Payment';
import Receipt from './pages/Receipt';
import Track from './pages/Track';
import Dashboard from './pages/Dashboard';
import Admin from './pages/Admin';
import Partner from './pages/Partner';
import Agent from './pages/Agent';
import Pricing from './pages/Pricing';
import FAQ from './pages/FAQ';
import About from './pages/About';
import Terms from './pages/Terms';
import Policies from './pages/Policies';
import Support from './pages/Support';
import { PWARoleRedirect } from './components/PWARoleRedirect';
import { ScrollToTop } from './components/ScrollToTop';
import './App.css';

// Global axios interceptor — auto-attaches the customer `user_session_token`
// (minted by the backend on OTP verification) to EVERY /api call, so
// protected endpoints like PATCH /users/{id}/profile and GET /bookings/{id}
// authenticate transparently. Role-specific requests already carry their
// own Bearer tokens explicitly, so we only inject the customer token when
// no Authorization header has been set by the caller.
axios.interceptors.request.use((config) => {
  try {
    if (!config.headers?.Authorization) {
      const t = typeof window !== 'undefined' ? window.localStorage.getItem('user_session_token') : null;
      if (t) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${t}`;
      }
    }
  } catch { /* localStorage unavailable in some contexts — ignore */ }
  return config;
});

// If the backend ever returns 401 (session expired), drop the stale token
// so the next navigation goes back through login instead of looping errors.
axios.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && err?.config?.url?.includes('/api/')) {
      try { window.localStorage.removeItem('user_session_token'); } catch { /* noop */ }
    }
    return Promise.reject(err);
  }
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <PWARoleRedirect />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/install" element={<Install />} />
          <Route path="/luggage-form" element={<LuggageForm />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/receipt" element={<Receipt />} />
          <Route path="/track" element={<Track />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/partner" element={<Partner />} />
          <Route path="/agent" element={<Agent />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/about" element={<About />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/policies" element={<Policies />} />
          <Route path="/support" element={<Support />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
